import React from 'react'
import FoilMetadataUploadContainer from './csv-upload/FoilMetadataUploadContainer'
import withLayout from '../../../layout/withLayout'
import FoilInfoTableContainer from './info-table/FoilInfoTableContainer'


const FoilOverview = () => {
    return (
        <React.Fragment>
            <FoilMetadataUploadContainer/>
            <FoilInfoTableContainer/>
        </React.Fragment>
    )
}

FoilOverview.propTypes = {

}

export default withLayout(FoilOverview)



// WEBPACK FOOTER //
// ./src/modules/foil/component/overview/FoilOverview.js